import { MessagePreviewOrderProps } from "../types"
import React from "react"
import { useTheme } from "~/ui/styled"
import { Text } from "~components/El"
import PreviewWrap from "./preview-wrap"
import PreviewText from "./preview-text"
// import { formatPrice } from "~utils"
// import { useStores } from "~models"

const MessagePreviewTrans: React.FC<MessagePreviewOrderProps> = ({
  senderName,
  forwardPrependMsg,
  message,
}) => {
  const theme= useTheme()
  // const { userStore } = useStores()
  // const isReceiver = message.receiver.id === userStore.currentUser.id
  const contentOverride = "已转账, 请查收"
  return (
    <PreviewWrap>
      <PreviewText numberOfLines={1}>
        {senderName}
        {forwardPrependMsg}
        <Text color={theme.colors.error}> {'[转账]'} </Text>
        {contentOverride}
      </PreviewText>
    </PreviewWrap>
  )
}
export default MessagePreviewTrans
